import { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
// --------------------- Import Antd-Design ---------------------
import {
  Col,
  Flex,
  Button,
  Row,
  MenuProps,
  Skeleton,
  Table,
  Typography,
} from "antd";
import type { TableProps } from "antd/es/table";
// --------------------- Import Material Icon ---------------------
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
// --------------------- Import Styles ---------------------
import { Container } from "./styles";
// --------------------- Import Components ---------------------
import { Columns } from "./components/Columns";
// --------------------- Import Hooks ---------------------
import { useEmpreendimentos } from "./hooks/useBuscarEmpreend";

// import { useGerenciarFiltros } from "./hooks/useGerenciarFiltros";
// --------------------- Import Utéis ---------------------
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";
import { useWarning } from "../../uteis/mensagens/useWarning";

// --------------------- Import Modal ---------------------
import ModalEditar from "./components/ModalEditar";
import ModalExcluir from "./components/ModalExcluir";
import ModalEmpreendimento from "./components/ModalEmpreendimento";
import ModalCaracteristicas from "./components/ModalCaracteristicas";
import ModalAptoInfo from "./components/ModalAptoInfo";

export default function ViewGerenciarApto() {
  // Traz o estilo Title da biblioteca
  const { Title } = Typography;
  // Controle de Paginação
  const [currentPage, setCurrentPage] = useState(1);

  // Definições para mobile
  const isMobile = useMediaQuery("(max-width:600px)");

  // Armazena o valor do Id do Empreendimento
  const [empreendId, setEmpreendId] = useState<number | null>(null);

  // Definições para exibir a mensagem de alerta
  const [warning, setWarning] = useState<string | undefined>();
  const { showWarning, contextHolder } = useWarning();
  const [warningDisplayed, setWarningDisplayed] = useState(false);

  // Busca os empreendimentos
  const { empreendimentos, isLoading, buscar } = useEmpreendimentos();

  // Verificação de permissaão
  const { isLoading: isTokenLoading, isValid } = usePermissao("OPE");

  const [filteredInfo, setFilteredInfo] = useState<{
    empreend?: string[] | null;
    cidadeId?: string[] | null;
    cronograma?: string[] | null;
    origem?: string[] | null;
  }>({
    empreend: null,
    cidadeId: null,
    cronograma: null,
    origem: null,
  });

  const [semFiltros, setSemFiltros] = useState(true);

  // Modal Cadastrar Empreendimento
  const [openModalAdd, setOpenModalAdd] = useState<boolean>(false);
  const handleModalAdd = () => {
    setOpenModalAdd(!openModalAdd);
  };

  // Modal Editar
  const [openModalEdit, setOpenModalEdit] = useState<boolean>(false);
  const handleModalEditar = () => {
    setOpenModalEdit(!openModalEdit);
  };

  // Modal Excluir
  const [openModalExcluir, setOpenModalExcluir] = useState<boolean>(false);
  const handleModalExcluir = () => {
    setOpenModalExcluir(!openModalExcluir);
  };

  // Caracteristicas
  const [openModalCaracteristicas, setOpenModalCaracteristicas] =
    useState<boolean>(false);
  const handleModalCaracteristicas = () => {
    setOpenModalCaracteristicas(!openModalCaracteristicas);
  };

  // ------------------------------  ---------------------------

  // OnClick das opções e funções que serão realizadas do item Ações
  const onClick: MenuProps["onClick"] = async ({ key }) => {
    switch (key) {
      // Editar
      case "1":
        handleModalEditar();
        break;

      // Excluir
      case "2":
        handleModalExcluir();
        break;

      // Excluir
      case "3":
        handleModalCaracteristicas();
        break;

      // Apartamentos
      case "4":
        handleModalAptoInfo();
        break;
    }
  };
  // Traz as informações  OnClick, origem , nome e id do Empreendimento além do nome do empreendimento, ao clickar na linha especifica
  const columns = Columns(onClick, setEmpreendId, {
    empreend: filteredInfo.empreend,
    cidadeId: filteredInfo.cidadeId,
    cronograma: filteredInfo.cronograma,

    origem: filteredInfo.origem,
  });

  // useEffect para lidar com a mensagem
  useEffect(() => {
    if (warning && !warningDisplayed) {
      // Verifica se a mensagem já foi exibida
      showWarning(warning);
      setWarningDisplayed(true);
    }

    // Limpa o estado de mensagem
    setTimeout(() => {
      setWarningDisplayed(false);
      setWarning(undefined);
    }, 3000);
  }, [showWarning, warningDisplayed, warning]);

  useEffect(() => {
    const filtros = localStorage.getItem("filtrosPropriedades");
    const pagina = localStorage.getItem("pageGerPropriedades");

    if (filtros) {
      const novoFiltro = JSON.parse(filtros);
      setFilteredInfo({
        empreend: novoFiltro.empreendimento
          ? [novoFiltro.empreendimento]
          : null,
        cidadeId: novoFiltro.cidadeId ? [novoFiltro.cidadeId] : null,
        cronograma: novoFiltro.cronograma ? [novoFiltro.cronograma] : null,

        origem: novoFiltro.origem ? [novoFiltro.origem] : null,
      });
      setSemFiltros(false);
    }

    if (pagina) {
      setCurrentPage(Number(pagina));
    }
  }, []);

  const onChange: TableProps<any>["onChange"] = (pagination, filters) => {
    setFilteredInfo({
      empreend: filters.empreendimento as string[] | null,
      cidadeId: filters.cidadeId as string[] | null,
      cronograma: filters.cronograma as string[] | null,

      origem: filters.origem as string[] | null,
    });

    const hasFilters = Boolean(
      filters.empreendimento ||
        filters.cidadeId ||
        filters.origem ||
        filters.cronograma
    );
    setSemFiltros(!hasFilters);

    if (pagination.current) {
      localStorage.setItem(
        "pageGerPropriedades",
        pagination.current.toString()
      );
    }

    localStorage.setItem("filtrosPropriedades", JSON.stringify(filters));
  };

  const removerFiltros = () => {
    localStorage.removeItem("filtrosPropriedades");
    localStorage.removeItem("pageGerPropriedades");

    setFilteredInfo({
      empreend: null,
      cidadeId: null,
      cronograma: null,
      origem: null,
    });
    setSemFiltros(true);
    setCurrentPage(1);
  };

  const handleFilter = () => {
    removerFiltros();
  };

  // State de abertura e fechamento do modal (Criar Empreendimento)
  const [openModalAptoInfo, setOpenModalAptoInfo] = useState(false);
  const handleModalAptoInfo = () => {
    setOpenModalAptoInfo(!openModalAptoInfo);
  };
  return (
    <>
      {(isLoading && isTokenLoading) || !isValid ? (
        <Skeleton active />
      ) : (
        <>
          {contextHolder}
          <Container>
            <Row>
              <Col span={5}>
                <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                  <a></a>
                </Flex>
              </Col>
              <Col span={12}>
                <Flex align="center" justify="center">
                  <HomeIcon color="primary" fontSize="large" />
                  <Title
                    style={{
                      marginLeft: 10,
                      marginTop: 10,
                      fontSize: isMobile ? "1rem" : "2rem",
                      color: "rgb(0, 54, 68)",
                    }}
                    level={3}
                  >
                    Gerenciar Empreendimentos
                  </Title>
                </Flex>
              </Col>
            </Row>

            <Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  height: "auto",
                  width: "90%",
                  gap: "20px",
                }}
              >
                <div style={{ display: "flex", gap: "20px" }}>
                  <Button
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "auto",
                      marginTop: isMobile ? 10 : "0",
                      marginBottom: isMobile ? 0 : "40px",
                      marginLeft: isMobile ? 100 : "1300px",
                    }}
                    onClick={handleModalAdd}
                    type="primary"
                  >
                    + Empreendimento
                  </Button>

                  {semFiltros ? (
                    <Button
                      onClick={handleFilter}
                      type="primary"
                      disabled
                      style={{ marginBottom: 8 }}
                    >
                      <FilterAltIcon />
                    </Button>
                  ) : (
                    <Button
                      onClick={handleFilter}
                      type="primary"
                      style={{ marginBottom: 8 }}
                    >
                      <FilterAltOffIcon />
                    </Button>
                  )}
                </div>
              </div>

              <Col span={isMobile ? 5 : 1}></Col>
              <Col
                span={22}
                style={{
                  marginTop: isMobile ? 15 : 15,
                  marginBottom: isMobile ? 30 : 50,
                }}
              >
                <Flex
                  style={{
                    width: isMobile ? "auto" : "100%",
                    overflow: "auto",
                    marginLeft: 30,
                  }}
                >
                  <Table
                    columns={columns}
                    dataSource={empreendimentos}
                    onChange={onChange}
                    bordered
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      width: isMobile ? "auto" : "100%",
                      maxWidth: isMobile ? "none" : "100%",
                    }}
                    pagination={{ defaultCurrent: currentPage }}
                  />
                </Flex>
              </Col>
              <Col span={1}></Col>
            </Row>
          </Container>

          <ModalEmpreendimento
            isModalOpen={openModalAdd}
            handleFechar={handleModalAdd}
          />

          <ModalEditar
            isModalOpen={openModalEdit}
            handleFechar={handleModalEditar}
            empreendId={empreendId!}
          />
          <ModalExcluir
            isModalOpen={openModalExcluir}
            handleFechar={handleModalExcluir}
            empreendId={empreendId!}
            buscar={buscar}
          />

          <ModalCaracteristicas
            isModalOpen={openModalCaracteristicas}
            handleFechar={handleModalCaracteristicas}
            empreendId={empreendId!}
            buscar={buscar}
          />
          <ModalAptoInfo
            isModalOpen={openModalAptoInfo}
            handleFechar={handleModalAptoInfo}
            empreendId={empreendId}
          />
        </>
      )}
    </>
  );
}
